var map = {
	"./dashboard/routes.ts": "./src/router/dashboard/routes.ts",
	"./emissao-certificado/atualizacao-conclusao-ensino/routes.ts": "./src/router/emissao-certificado/atualizacao-conclusao-ensino/routes.ts",
	"./emissao-certificado/manutencao-registro-certificado-geja/routes.ts": "./src/router/emissao-certificado/manutencao-registro-certificado-geja/routes.ts",
	"./emissao-certificado/manutencao-registro-certificado/routes.ts": "./src/router/emissao-certificado/manutencao-registro-certificado/routes.ts",
	"./relacao-de-alunos-concludentes/routes.ts": "./src/router/relacao-de-alunos-concludentes/routes.ts",
	"./tabelas-basicas/livros-e-formularios/manutencao-de-livro-de-registro-de-certificado/routes.ts": "./src/router/tabelas-basicas/livros-e-formularios/manutencao-de-livro-de-registro-de-certificado/routes.ts",
	"./tabelas-basicas/livros-e-formularios/manutencao-remessa-formulario/routes.ts": "./src/router/tabelas-basicas/livros-e-formularios/manutencao-remessa-formulario/routes.ts",
	"./tabelas-basicas/parametrizacao-certificados/manutencao-parametro-certificado/routes.ts": "./src/router/tabelas-basicas/parametrizacao-certificados/manutencao-parametro-certificado/routes.ts",
	"./tabelas-basicas/parametrizacao-certificados/manutencao-tipo-certificado-ensino/routes.ts": "./src/router/tabelas-basicas/parametrizacao-certificados/manutencao-tipo-certificado-ensino/routes.ts",
	"./tabelas-basicas/parametrizacao-certificados/manutencao-tipo-certificado/routes.ts": "./src/router/tabelas-basicas/parametrizacao-certificados/manutencao-tipo-certificado/routes.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router sync recursive routes.ts$/";